module.exports = __webpack_public_path__ + "img/hero-lg.7df03024.png";